import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Hourglass: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.2192 10.8493V9.65194C8.2192 8.24168 7.1295 7.39823 6.0822 6.57534C5.93754 6.46193 5.75341 6.24656 5.75341 5.9178C5.75341 5.58905 5.91928 5.26849 6.0822 5.13138C7.10119 4.27397 8.2192 3.46502 8.2192 2.05479V1.15069H9.04111V0H0V1.15069H0.821906V2.05481C0.821906 3.46507 1.93987 4.27399 2.95891 5.13141C3.12183 5.26852 3.28769 5.58905 3.28769 5.91783C3.28769 6.24661 3.10357 6.46193 2.95891 6.57537C1.91163 7.39828 0.821906 8.24173 0.821906 9.65196V10.8493H0V12H9.04109V10.8493H8.2192ZM2.44488 3.12328C2.14191 2.78037 1.97262 2.4503 1.97262 2.05479V1.15069H7.06849V2.05481C7.06849 2.4503 6.89916 2.78041 6.59623 3.1233H2.44488V3.12328ZM7.06849 10.5286L5.13321 9.7733C4.79623 9.64179 4.24505 9.64179 3.90806 9.7733L1.97262 10.5287V9.65201C1.97262 8.85408 2.60681 8.31525 3.64177 7.5022L3.66921 7.48069C4.06207 7.17263 4.31688 6.7436 4.40337 6.27082C4.48078 6.28807 4.56035 6.28807 4.63777 6.27082C4.7239 6.74344 4.97902 7.17248 5.37138 7.4802L5.39932 7.5022C6.43427 8.3152 7.06847 8.85389 7.06847 9.65198L7.06849 10.5286Z"
        fill="currentColor"
      />
    </svg>
  )
})

Hourglass.displayName = 'Hourglass'
